export const auditLogTypes = [
  { id: 'automationrule:create', name: 'Created a new automation' },
  { id: 'automationrule:update', name: 'Updated an automation' },
  { id: 'automationrule:destroy', name: 'Deleted an automation' },
  { id: 'webhook:create', name: 'Created a new webhook' },
  { id: 'webhook:update', name: 'Updated a webhook' },
  { id: 'webhook:destroy', name: 'Deleted a webhook' },
  { id: 'inbox:create', name: 'Created a new inbox' },
  { id: 'inbox:update', name: 'Updated an inbox' },
  { id: 'inbox:destroy', name: 'Deleted an inbox' },
  { id: 'user:sign_in', name: 'Signed in' },
  { id: 'user:sign_out', name: 'Signed out' },
  { id: 'team:create', name: 'Created a new team' },
  { id: 'team:update', name: 'Updated a team' },
  { id: 'team:destroy', name: 'Deleted a team' },
  { id: 'macro:create', name: 'Created a new macro' },
  { id: 'macro:update', name: 'Updated a macro' },
  { id: 'macro:destroy', name: 'Deleted a macro' },
  { id: 'accountuser:create', name: 'Invited to the account' },
  { id: 'accountuser:update:self', name: 'Changed their account attributes' },
  { id: 'accountuser:update:other', name: 'Changed other account attributes' },
  { id: 'inboxmember:create', name: 'Added member to the inbox' },
  { id: 'inboxmember:destroy', name: 'Removed member from the inbox' },
  { id: 'teammember:create', name: 'Added member to the team' },
  { id: 'teammember:destroy', name: 'Removed member from the team' },
  { id: 'account:update', name: 'Updated the account configuration' },
  { id: 'gpt_set_settings', name: 'Updated chatGPT settings' },
  { id: 'click2call_set_settings', name: 'Updated Click2Call settings' },
  { id: 'integrations_hook:create', name: 'Activated an integration' },
  { id: 'integrations_hook:destroy', name: 'Disconnected the integration' },
  { id: 'role:update', name: 'Updated Role Permissions' },
];
